import React, { FC } from 'react';

import { Descendant, Range } from 'slate';

import ImageMain from '../../../../../editors/PushNotificationEditor/Editor/components/Image/ImageMain';
import styled from 'styled-components';

//constants
import aampeTheme from '../../../../../constants/aampeTheme';

import LabelHistoryMain from '../../LabelHistory/LabelHistoryMain';
//components
import CMSPlaceholderMain from '../../cms-filters/CMSPlaceholderModal/CMSPlaceholderMain';
import DatasetConfigurationalMain from '../datasets/datasetConfigurationalModal/DatasetConfigurationMain';
import FormulaLockUnlockMain from './FormulaLockUnlockMain';
import NotificationButtonMain from './notificationButton/NotificationButtonMain';

export enum FormulaEditorToolbarControls {
    CMS_PLACEHOLDER = 'cms_placeholder',
    DATASET_CONFIGURATION = 'dataset_configuration',
    FORMULA_LOCK_UNLOCK = 'formula_lock_unlock',
    ADD_BUTTON = 'add_button',
    SEND_TEST_MESSAGE = 'send_test_message',
    ADD_IMAGE = 'add_image',
    LABEL_HISTORY = 'label_history',
}

export const defaultToolbarControls: FormulaEditorToolbarControls[] = [
    FormulaEditorToolbarControls.CMS_PLACEHOLDER,
    FormulaEditorToolbarControls.DATASET_CONFIGURATION,
    FormulaEditorToolbarControls.FORMULA_LOCK_UNLOCK,
    FormulaEditorToolbarControls.SEND_TEST_MESSAGE,
    FormulaEditorToolbarControls.ADD_IMAGE,
    FormulaEditorToolbarControls.LABEL_HISTORY,
];

export const surfaceToolbarControls: FormulaEditorToolbarControls[] = [
    FormulaEditorToolbarControls.CMS_PLACEHOLDER,
    FormulaEditorToolbarControls.DATASET_CONFIGURATION,
    FormulaEditorToolbarControls.FORMULA_LOCK_UNLOCK,
    FormulaEditorToolbarControls.LABEL_HISTORY,
];

export const emailToolbarControls: FormulaEditorToolbarControls[] = [
    FormulaEditorToolbarControls.CMS_PLACEHOLDER,
    FormulaEditorToolbarControls.DATASET_CONFIGURATION,
    FormulaEditorToolbarControls.FORMULA_LOCK_UNLOCK,
    FormulaEditorToolbarControls.ADD_BUTTON,
    FormulaEditorToolbarControls.SEND_TEST_MESSAGE,
    FormulaEditorToolbarControls.LABEL_HISTORY,
];

export const pushToolbarControls: FormulaEditorToolbarControls[] = [
    FormulaEditorToolbarControls.CMS_PLACEHOLDER,
    FormulaEditorToolbarControls.DATASET_CONFIGURATION,
    FormulaEditorToolbarControls.FORMULA_LOCK_UNLOCK,
    FormulaEditorToolbarControls.ADD_BUTTON,
    FormulaEditorToolbarControls.SEND_TEST_MESSAGE,
    FormulaEditorToolbarControls.ADD_IMAGE,
    FormulaEditorToolbarControls.LABEL_HISTORY,
];

interface FormulaEditorToolbarProps {
    handleUpdateStructure: (newValue: Descendant[]) => void;
    isEditable: boolean;
    selectedElement?: { [key: string]: any };
    formulaId?: number;
    currentSelection?: Range;
    toolbarControls?: FormulaEditorToolbarControls[];
    hasWriteAccess?: boolean;
}

const FormulaEditorToolbar: FC<FormulaEditorToolbarProps> = ({
    handleUpdateStructure,
    isEditable,
    selectedElement,
    formulaId,
    currentSelection,
    toolbarControls = defaultToolbarControls,
    hasWriteAccess,
}) => {
    return (
        <>
            <EditorLowerMenuIcon>
                <Content>
                    {toolbarControls.includes(
                        FormulaEditorToolbarControls.CMS_PLACEHOLDER,
                    ) && <CMSPlaceholderMain isEditable={isEditable} />}
                    {toolbarControls.includes(
                        FormulaEditorToolbarControls.DATASET_CONFIGURATION,
                    ) && <DatasetConfigurationalMain isEditable={isEditable} />}
                </Content>
                <Content>
                    {toolbarControls.includes(
                        FormulaEditorToolbarControls.FORMULA_LOCK_UNLOCK,
                    ) && <FormulaLockUnlockMain isEditable={isEditable} />}
                    {toolbarControls.includes(
                        FormulaEditorToolbarControls.ADD_BUTTON,
                    ) &&
                        hasWriteAccess && <NotificationButtonMain />}
                    {toolbarControls.includes(
                        FormulaEditorToolbarControls.ADD_IMAGE,
                    ) && (
                        <ImageMain
                            handleUpdateStructure={handleUpdateStructure}
                            isEditable={isEditable}
                        />
                    )}
                    {toolbarControls.includes(
                        FormulaEditorToolbarControls.LABEL_HISTORY,
                    ) &&
                        hasWriteAccess && (
                            <LabelHistoryMain
                                currentSelection={currentSelection}
                                formulaId={formulaId}
                                selectedElement={selectedElement}
                            ></LabelHistoryMain>
                        )}
                </Content>
            </EditorLowerMenuIcon>
        </>
    );
};

const EditorLowerMenuIcon = styled.div({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: aampeTheme.spacing4(5, 4),
    backgroundColor: aampeTheme.colors.backgroundWG01,
    gap: aampeTheme.spacing4(4),
    border: `1px solid ${aampeTheme.colors.backgroundWG02}`,
    borderRadius: aampeTheme.borderRadius.default,
});

const Content = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(4),
});

export default FormulaEditorToolbar;
